export const trendsPath = {
  /* inject path */
  LAST_FIVE_TRENDING_HASHTAGS: '/trends/last-five-trending-hashtags',
  TOPICS_OVER_COUNTRY: '/trends/topics-over-country/:id',
  ARTICLE_DETAILS: '/trends/news/article-details/:id',
  ARTICLE_DETAILS_URI: '/trends/news/article-details',
  TOPIC_VIEW: '/trends/topic-view/:id',
  TOPIC_VIEW_URI: '/trends/topic-view',
  COMPARE_TOPICS: '/trends/compare-topics',
  VIDEO_VIEW: '/trends/videos/video-view/:id',
  VIDEO_VIEW_URI: '/trends/videos/video-view',
  COMPARE_VIDEOS: '/trends/compare-videos',
  COMPARE_HASHTAGS: '/trends/compare-hashtags',
  UN_ANALYZE_HASHTAG: '/trends/news/unanalyze-hashtage/:id',
  UN_ANALYZE_HASHTAG: '/trends/unanalyze-hashtage',
  TRENDING_COMPARE: '/trends/trending-compare',
  TOPICS: '/trends/topics',
  TOPICS_DETAILS: '/trends/topics-details/:id',
  TOPICS_DETAILS_URI: '/trends/topics-details',
  VIDEOS: '/trends/videos',
  NEWS: '/trends/news',
  HASHTAGS: '/trends/hashtags',
  ALL: '/trends/all',
  TOP_COUNTRIES_WORLD_MAP: '/trends/top-countries-map',
  HASHTAG_VIEW: '/trends/hashtags/hashtag-view/:id/:name?',
  HASHTAG_VIEW_URI: '/trends/hashtags/hashtag-view',
};
